export enum VideoCallEvents {
    publisherCreated = 'publisher_created',
    publisherAlreadyCreated = 'publisher_already_created',
    publisherDestroyed = 'publisher_destroyed',
    publisherConfigured = 'publisher_configured',
    publisherCreationFailed = 'publisher_creation_failed',
    publisherDevicesInUse = 'publisher_devices_in_use',
    publisherAudioOutputDeviceFailed = 'publisher_audio_output_device_failed',
    publisherCapabilitiesOk = 'publisher_capabilities_ok',
    publisherCapabilitiesKo = 'publisher_capabilities_ko',

    sessionInit = 'session_init',
    sessionCreationFailedByCredentials = 'session_creation_failed_by_credentials',
    sessionAlreadyCreated = 'session_already_created',
    sessionConnecting = 'session_connecting',
    sessionCreated = 'session_created',
    sessionConnected = 'session_connected',
    sessionConnectionFailed = 'session_connection_failed',
    sessionDisconnected = 'session_disconnected',
    
    publisherAttemptToConnect = 'publisher_attempt_to_connect',
    publisherConnected = 'publisher_connected',
    publisherAlreadyConnected = 'publisher_already_connected',
    publisherConnectionFailed = 'publisher_connection_failed',

    publisherScreenSharingStartFailed = 'publisher_screen_sharing_start_failed',
    publisherScreenSharingStarted = 'publisher_screen_sharing_started',
    publisherScreenSharingStopped = 'publisher_screen_sharing_stopped',
    publisherScreenSharingConnected = 'publisher_screen_sharing_connected',
    publisherScreenSharingDisconnected = 'publisher_screen_sharing_disconnected',
    
    participantAttemptToJoin = 'participant_attempt_to_join',
    participantJoined = 'participant_joined',
    participantLeft = 'participant_left',
    participantJoinFailed = 'participant_join_failed',

    participantJoinSubscriptionFailed = 'participant_join_subscription_failed',
    participantJoinSubscriptionSuccess = 'participant_join_subscription_success',

    participantAudioEnabled = 'participant_audio_enabled',
    participantAudioDisabled = 'participant_audio_disabled',
    participantVideoEnabled = 'participant_video_enabled',
    participantVideoDisabled = 'participant_video_disabled',
    participantMuted = 'participant_muted',
    participantUnmuted = 'participant_unmuted',

    participantScreenSharingStartFailed = 'participant_screen_sharing_start_failed',
    participantScreenSharingStarted = 'participant_screen_sharing_started',
    participantScreenSharingConnected = 'participant_screen_sharing_connected',
    participantScreenSharingDisconnected = 'participant_screen_sharing_disconnected',

    participantChatMessageSending = 'participant_chat_message_sending',
    participantChatMessageSent = 'participant_chat_message_sent',
    participantChatMessageSendFailed = 'participant_chat_message_send_failed',

    toggleCamVisibilityFailed = 'toggle_cam_visibility_failed',
    hideCam = 'hide_cam',
    showCam = 'show_cam',
    mute = 'mute',
    unmute = 'unmute',

    sendEventToVonageFailed = 'send_event_to_vonage_failed',
    sentEventToVonage = 'sent_event_to_vonage',
} 